// French for the client page's rail: the five field labels and the BALL figure.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Engagements': 'Mandats',
  'Day': 'Jour',
  'Ball': 'Balle',
  'Last contact': 'Dernier contact',
  'New': 'Nouveau',
  'WITH {who}': 'AVEC {who}',
}, 'ClientRail');
